













































































































































































import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import FilterComponent from '@/components/FilterComponent.vue';
import { fetchProspectsPrescriber } from '@/utils/filters';
import get from 'lodash/get';
import Customer from '../../models/Customer';
import {
    postCustomerPrescriber,
    postSaveSearchPrescriber,
} from '../../api/api';
import AutocompleteAddress from '@/components/AutocompleteAddress.vue';
import AdresseGouvFeature from '@/models/AdresseGouvFeature';
import AdresseGouvResult from '@/models/AdresseGouvResult';
import uniqBy from 'lodash/uniqBy';
import axios from 'axios';
import { civilities } from '@/data/civilitiesCustomer';
import FilterModule from '@/store/FiltersModule';
import transformFilters from '@/utils/transformFilters';
import moment from 'moment';
import departments from '../../data/departments';

@Component({
    components: {
        FilterComponent,
        AutocompleteAddress,
    },
    filters: {
        pluralize: (value: string, suffix: string, bool: boolean) => {
            if (bool) {
                return `${value}${suffix}`;
            }
            return value;
        },
    },
})
export default class DenouncePopup extends Vue {
    @PropSync('active', {
        default: false,
    })
    pActive!: boolean;
    sending: boolean = false;
    prospectID: number | null = null;
    errors: any = null;
    showConfirm: boolean = false;
    newProspect = {
        civility: '',
        first_firstname: '',
        first_lastname: '',
        second_firstname: '',
        second_lastname: '',
        company_name: '',
        email: '',
        birthdate: undefined,
        phone: '',
        mobile: '',
        address: {
            postal_code: '',
            city: '',
        },
    };

    get fetchProspectsPrescriber() {
        return fetchProspectsPrescriber;
    }

    formatSuggestZip(item: AdresseGouvFeature) {
        return `${item.properties.postcode} ${item.properties.city}`;
    }

    formatSuggestCity(item: AdresseGouvFeature) {
        return `${item.properties.city} ${item.properties.postcode}`;
    }

    onFilterProspect(prospectID: number | undefined) {
        if (prospectID === undefined) {
            this.prospectID = null;
        } else {
            this.prospectID = prospectID;
        }
    }

    getErrorsAddress(field: string): string[] {
        return get(
            this.errors,
            `children.address.children.${field}.errors`,
            []
        );
    }

    getErrors(field: string): string[] {
        return get(this.errors, `children.${field}.errors`, []);
    }

    async onSubmit() {
        this.showConfirm = true;
    }


    async searchZipAndCity(value: string) {
        // CHANGED HERE:
        const resp = await axios.get(
            `https://data.geopf.fr/geocodage/search?q=${value}`
        );
        const data: AdresseGouvResult = await resp.data;
        const result = uniqBy(data.features, item => {
            return `${item.properties.city} ${item.properties.postcode}`;
        });
        return result;
    }
    

    onItemZipAndCity(item: AdresseGouvFeature) {
        this.newProspect.address.postal_code = item.properties.postcode;
        this.newProspect.address.city = item.properties.city;
    }

    async accept() {
        this.showConfirm = false;

        try {
            this.sending = true;

            // on obtient le prospectID, on créé le prospect au besoin
            let prospectID: number | undefined = undefined;
            if (this.prospectID !== null) {
                prospectID = this.prospectID;
            } else {
                const customer: Customer = this.newProspect as Customer;
                const { data } = await postCustomerPrescriber(customer);
                prospectID = data.id;
            }

            // on enregistre la recherche
            if (prospectID !== undefined) {
                const filters = transformFilters(FilterModule.filters);

                await postSaveSearchPrescriber({
                    programStatus: filters.status,
                    programDeliveryDateMin: filters.dateInterval.min,
                    programDeliveryDateMax: filters.dateInterval.max,
                    lotPriceMin: filters.price.min,
                    lotPriceMax: filters.price.max,
                    departments: filters.departments,
                    city: filters.city,
                    programTaxSystem: filters.tax_system,
                    lotType: filters.type,
                    lotType2: filters.type2,
                    program: filters.program,
                    promoter: filters.promotor,
                    customer: prospectID,
                });

                this.pActive = false;
                await this.$nextTick();

                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'success',
                    position: 'top-right',
                    title: 'Sauvegarde réussie',
                    text: 'Votre recherche a bien été enregistrée',
                });
            }
        } catch (error) {
            this.errors = error.response.data.errors;
        } finally {
            this.sending = false;
        }
    }

    get isSelectProspectFilled() {
        return this.prospectID !== null;
    }

    get isNewProspectNotEmpty() {
        return (
            (this.newProspect.civility &&
                this.newProspect.civility.trim() !== '') ||
            this.newProspect.first_firstname.trim() !== '' ||
            this.newProspect.first_lastname.trim() !== '' ||
            this.newProspect.second_firstname.trim() !== '' ||
            this.newProspect.second_lastname.trim() !== '' ||
            this.newProspect.company_name.trim() !== '' ||
            this.newProspect.email.trim() !== ''
        );
    }

    get isFormValid() {
        return (
            this.isSelectProspectFilled ||
            (this.newProspect.civility &&
                this.newProspect.civility.trim() !== '' &&
                this.newProspect.first_firstname.trim() !== '') ||
            this.newProspect.first_lastname.trim() !== '' ||
            this.newProspect.second_firstname.trim() !== '' ||
            this.newProspect.second_lastname.trim() !== '' ||
            this.newProspect.company_name.trim() !== '' ||
            (this.newProspect.email.trim() !== '' &&
                this.newProspect.address.postal_code.trim() !== '' &&
                this.newProspect.address.city.trim() !== '')
        );
    }

    @Watch('pActive')
    onPActive() {
        if (this.pActive === false) {
            this.cleanup();
        }
    }
    @Watch('newProspect.civility', { deep: true })
    onChangeProspect() {
        if (this.newProspect.civility !== 'Société') {
            this.newProspect.company_name = '';
        } else {
            this.newProspect.first_firstname = '';
            this.newProspect.first_lastname = '';
        }
        if (
            this.newProspect.civility !== 'Mme. et Mme.' &&
            this.newProspect.civility !== 'Mr. et Mr.' &&
            this.newProspect.civility !== 'Mr. et Mme.'
        ) {
            this.newProspect.second_firstname = '';
            this.newProspect.second_lastname = '';
        }
    }
    cleanup() {
        this.prospectID = null;
        this.newProspect.civility = '';
        this.newProspect.first_firstname = '';
        this.newProspect.first_lastname = '';
        this.newProspect.second_firstname = '';
        this.newProspect.second_lastname = '';
        this.newProspect.company_name = '';
        this.newProspect.email = '';
        this.newProspect.address.postal_code = '';
        this.newProspect.address.city = '';
    }

    get customerCivilitiesArr() {
        return Object.keys(civilities).map(key => ({
            text: (civilities as any)[key],
            value: key,
        }));
    }
}
